import * as React from "react";
import { forwardRef } from "react";
const SvgPwcIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 8, viewBox: "0 0 32 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.6639 8H0L2.29201 4H15.9559L13.6639 8ZM32 0H18.3361L16.0441 4H29.708L32 0Z", fill: "#FD5108" }));
const ForwardRef = forwardRef(SvgPwcIcon);
export default ForwardRef;
